import { Filter } from "model/Filter/Filter";
import { Tournament } from "model/Tournament/Tournament";
import { selectTourTitleDisplayForTournamentId } from "selectors/Tour";
import { Header } from "../Header/Header";
import { useAppSelector } from "app/hooks";

interface Props {
  tournament: Tournament;
  tabFilter: Filter<string>;
}

export const TournamentHeader = ({ tournament, tabFilter }: Props) => {
  const tourTitle = useAppSelector((state) =>
    selectTourTitleDisplayForTournamentId(state, tournament.id)
  );

  const name = `${tournament.name}
  ${!!tourTitle ? ` - ${tourTitle}` : ""}`;

  return (
    <Header
      description={tournament.description}
      endTime={tournament.endTimeMs}
      id={tournament.id}
      links={tournament.links}
      name={name}
      startTime={tournament.startTimeMs}
      tabFilter={tabFilter}
      type="Tournament"
      theme={tournament.theme}
    />
  );
};
